import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IWhatsAppMessage, IWhatsAppSettings, WhatsAppMediaUrl } from 'services/whatsAppMessaging/types';
import { RootState } from 'store/index';
import {
  ThunkGetWhatsAppChatMessages,
  ThunkGetWhatsAppSettings,
} from 'store/whatsAppMessaging/thunks';

interface IInitialState {
  history: IWhatsAppMessage[];
  settings: unknown | null;
}

const initialState: IInitialState = {
  history: [],
  settings: null,
};

const whatsAppMessaging = createSlice({
  name: 'whatsAppMessaging',
  reducers: {
    addWhatsAppHistory: (state, action: PayloadAction<IWhatsAppMessage>) => {
      state.history.push(action.payload);
    },
    changeWhatsAppHistoryItemState: (
      state,
      action: PayloadAction<{
        id: string;
        loading: boolean;
        message?: string;
        mediaUrls?: WhatsAppMediaUrl[];
      }>,
    ) => {
      state.history = state.history.map(i =>
        i.id === action.payload.id
          ? {
              ...i,
              loading: action.payload.loading,
              message: action.payload?.message ?? i.message,
              mediaUrls: action.payload?.mediaUrls ?? i.mediaUrls,
            }
          : i,
      );
    },
  },
  initialState,
  extraReducers: builder => {
    builder.addCase(ThunkGetWhatsAppChatMessages.fulfilled, (state, action) => {
      state.history = action.payload;
    });
    builder.addCase(ThunkGetWhatsAppSettings.fulfilled, (state, action) => {
      state.settings = action.payload;
    });
  },
});

export default whatsAppMessaging.reducer;
export const { addWhatsAppHistory, changeWhatsAppHistoryItemState } = whatsAppMessaging.actions;
export const WhatsAppHistorySelector = (state: RootState): IWhatsAppMessage[] =>
  state.whatsAppMessaging.history;

export const hasWhatsAppSettingsSelector = (state: RootState): boolean => {
  const s = state.whatsAppMessaging.settings;
  return s != null && (Array.isArray(s) ? s.length > 0 : true);
};

export const hasWhatsAppSettingsForEuvSelector = (state: RootState): boolean => {
  const settings = state.whatsAppMessaging.settings as IWhatsAppSettings | null;
  return settings != null && settings.defaultEuvTemplateName != null && settings.defaultEuvTemplateName !== '';
};
